import React, { useEffect, useMemo } from "react";
import { Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";
import clsx from "clsx";

import CalculatorVesselDetails from "../../../../components/Calculator/CalculatorVesselDetails";
import MarginAndAllowances from "../../../../components/Calculator/MarginAndAllowances";
import ActionButtons from "../../../../components/Calculator/ActionButtons";
import VesselVesselDeliveryOut from "../../../../components/Calculator/VesselVesselDeliveryOut";
import VesselVesselReDeliveryIn from "../../../../components/Calculator/VesselVesselReDeliveryIn";
import CustomShowModal from "../../../../components/Common/CustomShowModal";
import SplitHireModal from "../../../../components/Calculator/SplitHireModal";
import VesselVesselPortOperations from "../../../../components/Calculator/VesselVesselPortOperations";
import VesselVesselResult from "../../../../components/Calculator/VesselVesselResult";
import ShowMap from "../../Calculator/ShowMap";
import { openMapInNewTab } from "../../Calculator/ShowMap/openMapTab";

import {
  vesselVesselExpenseResultsFields,
  vesselVesselResultsFields,
  vesselVesselRevenueResultsFields,
} from "../../../../constants";

import { useVesselVesselController } from "../hooks/useVesselVesselController";

export function VesselVesselView(props) {
  const { setLoader = () => {}, setIsFullScreen = () => {} } = props;
  const { id = "" } = useParams();

  const controller = useVesselVesselController(props);

  const {
    calculatorData,
    selectedVessels,
    syncBunker,
    isOverride,
    hideOrder,
    setHideOrder,
    isPublic,
    hideCalculator,
    setHideCalculator,
    marginModal,
    setMarginModal,
    supplyModal,
    setSupplyModal,
    splitHireModal,
    setSplitHireModal,
    splitHireModalVesselOut,
    setSplitHireModalVesselOut,
    openAddOperation,
    setOpenAddOperation,
    openAddOperationIndex,
    setOpenAddOperationindex,
    fleetCheckbox,
    setFleetCheckbox,
    selectedSplitHire,
    selectedSplitHireVesselOut,

    // Handlers
    getInitalQueryAndFleetData,
    onChangePortOperations,
    onFetchPortOperationDistance,
    sendCalculationRequest,
    onChangeFleetRowSelect,
    onClickCalculate,
    onClickCalculateAndSave,
    setCalculatorData,
    setSelectedVessels,
    setSyncBunker,
    setIsOverride,
    onChangeOverride,
  } = controller;

  const mapPortOperation = useMemo(() => {
    return calculatorData?.portOperation;
  }, [
    calculatorData?.portOperation
      ?.map((p) => `${p.port}_${p.lat}_${p.lng}_${p.geoJSON ? JSON.stringify(p.geoJSON) : ""}`)
      .join("|"),
  ]);

  const mapFleetList = useMemo(() => {
    return calculatorData?.fleetList;
  }, [
    calculatorData?.fleetList
      ?.map((f) => `${f.vesselName || f.vessel}_${f.port}`)
      .join("|"),
  ]);

  const mapDistanceResponse = useMemo(() => {
    return calculatorData?.clientQuery?.portToPortDistance?.output;
  }, [calculatorData?.clientQuery?.portToPortDistance?.output]);

  useEffect(() => {
    setIsFullScreen(true);
    if (id) {
      getInitalQueryAndFleetData(id);
      onChangeOverride(true);
    }
    return () => {
      setIsFullScreen(false);
    };
  }, [id]);

  const onSetOpenMap = () =>
    openMapInNewTab(id, {
      portOperation: mapPortOperation,
      fleetList: mapFleetList,
      portDistanceResponse: mapDistanceResponse,
    });

  const onSetHideCalculator = () => {
    setHideCalculator(!hideCalculator);
  };

  const openSplitHireModal = (fleet) => {
    controller.setSelectedSplitHire(fleet);
    setSplitHireModal(true);
  };

  const openSplitHireModalVesselOut = (fleet) => {
    controller.setSelectedSplitHireVesselOut(fleet);
    setSplitHireModalVesselOut(true);
  };

  const addNewSplitHire = () => {
    let splitHire =
      (selectedSplitHire &&
        selectedSplitHire.splitHire &&
        JSON.parse(selectedSplitHire.splitHire)) ||
      [];
    if (!!splitHire.find((item) => item.NoDays === 0)) return;
    splitHire.push({ NoDays: 0, applied: 0, disable: false, hireRate: 0 });
    controller.setSelectedSplitHire({
      ...selectedSplitHire,
      splitHire: JSON.stringify(splitHire),
    });
  };

  const addNewSplitHireVesselOut = () => {
    let splitHire =
      (selectedSplitHireVesselOut &&
        selectedSplitHireVesselOut.vesselOut &&
        selectedSplitHireVesselOut.vesselOut.splitHire &&
        JSON.parse(selectedSplitHireVesselOut.vesselOut.splitHire)) ||
      [];
    if (!!splitHire.find((item) => item.NoDays === 0)) return;
    splitHire.push({ NoDays: 0, applied: 0, disable: false, hireRate: 0 });
    controller.setSelectedSplitHireVesselOut({
      ...selectedSplitHireVesselOut,
      vesselOut: {
        ...selectedSplitHireVesselOut?.vesselOut,
        splitHire: JSON.stringify(splitHire),
      },
    });
  };

  const onChangeSplitHire = (index, e, isDelete = false) => {
    let splitHire =
      (selectedSplitHire &&
        selectedSplitHire.splitHire &&
        JSON.parse(selectedSplitHire.splitHire)) ||
      [];
    if (isDelete) splitHire.splice(index, 1);
    else {
      const { name = "", value = "" } = e.target;
      splitHire[index][name] = Number(value);
    }
    const udpatedSelectedSplitHire = {
      ...selectedSplitHire,
      splitHire: JSON.stringify(splitHire),
    };
    controller.setSelectedSplitHire(udpatedSelectedSplitHire);

    setCalculatorData({
      ...calculatorData,
      fleetList: (calculatorData.fleetList || []).map((item) => {
        if (item._id === udpatedSelectedSplitHire._id) {
          return udpatedSelectedSplitHire;
        }
        return item;
      }),
    });
    if (udpatedSelectedSplitHire._id === selectedVessels._id)
      setSelectedVessels(udpatedSelectedSplitHire);
  };

  const onChangeSplitHireVesselOut = (index, e, isDelete = false) => {
    let splitHire =
      (selectedSplitHireVesselOut &&
        selectedSplitHireVesselOut.vesselOut &&
        selectedSplitHireVesselOut.vesselOut.splitHire &&
        JSON.parse(selectedSplitHireVesselOut.vesselOut.splitHire)) ||
      [];
    if (isDelete) splitHire.splice(index, 1);
    else {
      const { name = "", value = "" } = e.target;
      splitHire[index][name] = Number(value);
    }
    const udpatedSelectedSplitHire = {
      ...selectedSplitHireVesselOut,
      vesselOut: {
        ...selectedSplitHireVesselOut?.vesselOut,
        splitHire: JSON.stringify(splitHire),
      },
    };
    controller.setSelectedSplitHireVesselOut(udpatedSelectedSplitHire);

    setCalculatorData({
      ...calculatorData,
      fleetList: (calculatorData.fleetList || []).map((item) => {
        if (item._id === udpatedSelectedSplitHire._id) {
          return udpatedSelectedSplitHire;
        }
        return item;
      }),
    });
    if (udpatedSelectedSplitHire._id === selectedVessels._id)
      setSelectedVessels(udpatedSelectedSplitHire);
  };

  const onChangeSelectedVessel = (e, isFleetEdit = false) => {
    const { name = "", value = "", type = "number", checked = false } = e.target || {};
    let newUpdatedFleet = { ...selectedVessels };
    const { fuelType = "" } = calculatorData.clientQuery || {};
    let updatedvessel = { ...JSON.parse(newUpdatedFleet.vessel || "{}") };

    if (isFleetEdit) {
      newUpdatedFleet[name] = value;
    } else {
      if (type === "checkbox") {
        updatedvessel[name] = checked;
      } else {
        updatedvessel[name] = value;
      }
    }
    const updatedFleet = {
      ...newUpdatedFleet,
      vessel: JSON.stringify(updatedvessel),
    };
    setSelectedVessels(updatedFleet);
    const updatedFleetList = (calculatorData.fleetList || []).map((item) => {
      if (item._id === updatedFleet._id) return updatedFleet;
      return item;
    });

    let updatedPortOperation = [...(calculatorData.portOperation || [])];
    if (["bnkPriceDeliveryhs", "bnkPriceDeliveryls", "bnkPriceDeliverymgo"].includes(name)) {
      const currentType = fuelType.replace("TYPE", "");
      if (name === "bnkPriceDeliveryhs" && updatedPortOperation[0]) updatedPortOperation[0].cargoDetails[`fuelPriceType${currentType}Hsfo`] = value;
      if (name === "bnkPriceDeliveryls" && updatedPortOperation[0]) updatedPortOperation[0].cargoDetails[`fuelPriceType${currentType}Lsfo`] = value;
      if (name === "bnkPriceDeliverymgo" && updatedPortOperation[0]) updatedPortOperation[0].cargoDetails[`fuelPriceType${currentType}Mgo`] = value;
    }

    if (["bnkDelhs", "bnkDells", "bnkDelmgo"].includes(name)) {
      if (updatedPortOperation.length && updatedPortOperation[0].cargoDetails) {
        if (name === "bnkDelhs") updatedPortOperation[0].cargoDetails.bunkerSuppliedHSFO = value;
        if (name === "bnkDells") updatedPortOperation[0].cargoDetails.bunkerSuppliedLSFO = value;
        if (name === "bnkDelmgo") updatedPortOperation[0].cargoDetails.bunkerSuppliedMGO = value;
      }
    }

    setCalculatorData({
      ...calculatorData,
      portOperation: updatedPortOperation,
      fleetList: updatedFleetList,
    });
  };

  const onChangeSelectedVesselOut = (e) => {
    const { name = "", value = "" } = e.target || {};
    let updatedvessel = { ...selectedVessels?.vesselOut };
    updatedvessel[name] = value;

    const updatedFleet = {
      ...selectedVessels,
      vesselOut: updatedvessel,
    };
    setSelectedVessels(updatedFleet);
    setCalculatorData({
      ...calculatorData,
      fleetList: [updatedFleet],
    });
  };

  const onChangeSyncBunker = (checked) => {
    let updatedClientQuery = { ...calculatorData.clientQuery };
    let updatedCalculatorData = { ...calculatorData };

    let clientQuery = {
      ...updatedCalculatorData.clientQuery,
      fuelPriceOverridden: checked,
      fuelCalculationMethod:
        !updatedCalculatorData.clientQuery.fuelCalculationMethod || updatedCalculatorData.clientQuery.fuelCalculationMethod === "DEFAULT"
          ? "LIFO"
          : updatedCalculatorData.clientQuery.fuelCalculationMethod,
    };
    if (!checked) {
      clientQuery = {
        ...updatedCalculatorData.clientQuery,
        fuelPriceOverridden: checked,
        fuelCalculationMethod: "DEFAULT",
      };
    }

    setCalculatorData({
      ...updatedCalculatorData,
      clientQuery,
    });
  };

  return (
    <div className="calculator-section flex flex-col min-h-[calc(100vh-60px)] w-full p-2">
      <div className="flex flex-row">
        <div className="flex flex-col main-content-wrapper-inner w-full">
          <div className="quick-menu-bar">
            <ActionButtons
              hideOrder={hideOrder}
              setHideOrder={setHideOrder}
              onSetOpenMap={onSetOpenMap}
              onClickCalculate={onClickCalculate}
              onSetHideCalculator={onSetHideCalculator}
              onClickCalculateAndSave={onClickCalculateAndSave}
              isFromSingleVesselCalcy
              isPublic={isPublic}
            />
          </div>

          <div>
            {!id ? (
              <div className="h-100">
                <div className="flex">
                  <p className="m-a text-xl">Please select an id.</p>
                </div>
              </div>
            ) : (
              <div className="calc-secound-section p-2 pt-1">
                <div className="flex flex-col gap-2">
                  {!hideCalculator && (
                    <div className="grid grid-cols-6 gap-1.5 all-content-tables">
                      <div className="upper-section-grid col-span-2">
                        <CalculatorVesselDetails
                          setLoader={setLoader}
                          setSelectedVessels={setSelectedVessels}
                          selectedVessels={selectedVessels}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          onChangeHandler={onChangeSelectedVessel}
                          fleetCheckbox={fleetCheckbox}
                          setFleetCheckbox={setFleetCheckbox}
                          disableEdit
                        />
                      </div>

                      <div className="upper-section-grid">
                        <MarginAndAllowances
                          onChangeSelectedVessel={onChangeSelectedVessel}
                          selectedVessels={selectedVessels}
                          setSelectedVessels={setSelectedVessels}
                          setMarginModal={setMarginModal}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          syncBunker={syncBunker}
                          setSyncBunker={setSyncBunker}
                          setSupplyModal={setSupplyModal}
                          onChangeSyncBunker={onChangeSyncBunker}
                          isOverride={isOverride}
                          isFromVesselVessel
                        />
                      </div>

                      <div className="upper-section-grid">
                        <VesselVesselDeliveryOut
                          onChangeSelectedVessel={onChangeSelectedVessel}
                          selectedVessels={selectedVessels}
                          openSplitHireModal={openSplitHireModal}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          addNewSplitHire={addNewSplitHire}
                          onChangeSplitHire={onChangeSplitHire}
                          isOverride={isOverride}
                          isFromSingleVesselCalcy
                          label="Vessel-in"
                        />
                      </div>

                      <div className="upper-section-grid">
                        <VesselVesselReDeliveryIn
                          onChangeSelectedVessel={onChangeSelectedVesselOut}
                          selectedVessels={selectedVessels}
                          openSplitHireModal={openSplitHireModalVesselOut}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          addNewSplitHire={addNewSplitHire}
                          onChangeSplitHire={onChangeSplitHire}
                          isOverride={isOverride}
                          isFromSingleVesselCalcy
                          label="Vessel-out"
                        />
                      </div>

                      <div className="upper-section-grid">
                        <VesselVesselResult
                          selectedVessels={selectedVessels}
                          calculationErrors={controller.calculationErrors}
                          label="Revenue"
                          fields={vesselVesselRevenueResultsFields}
                        />
                        <VesselVesselResult
                          selectedVessels={selectedVessels}
                          calculationErrors={controller.calculationErrors}
                          label="Expense"
                          fields={vesselVesselExpenseResultsFields}
                        />
                        <VesselVesselResult
                          selectedVessels={selectedVessels}
                          calculationErrors={controller.calculationErrors}
                          label="Result"
                          fields={vesselVesselResultsFields}
                        />
                      </div>
                    </div>
                  )}

                  <div>
                    {calculatorData && (
                      <div className="middle-section-grid w-full">
                        <VesselVesselPortOperations
                          marginModal={marginModal}
                          setMarginModal={setMarginModal}
                          sendCalculationRequest={sendCalculationRequest}
                          onChangePortOperations={onChangePortOperations}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          syncBunker={syncBunker}
                          setSyncBunker={setSyncBunker}
                          onAddOperations={controller.onAddOperations}
                          onDeleteOperations={controller.onDeleteOperations}
                          selectedVessels={selectedVessels}
                          supplyModal={supplyModal}
                          setSupplyModal={setSupplyModal}
                          onChangeSyncBunker={onChangeSyncBunker}
                          onFetchPortOperationDistance={onFetchPortOperationDistance}
                          fetchPortDistance={controller.fetchPortDistance}
                          openAddOperation={openAddOperation}
                          openAddOperationIndex={openAddOperationIndex}
                          setOpenAddOperation={setOpenAddOperation}
                          setOpenAddOperationindex={setOpenAddOperationindex}
                          onChangeSelectedVessel={onChangeSelectedVessel}
                          isOverride={isOverride}
                          setIsOverride={onChangeOverride}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {calculatorData?.clientQuery?._id &&
                  calculatorData?.clientQuery?.portToPortDistance?.output &&
                  Object.keys(calculatorData?.clientQuery?.portToPortDistance?.output || {}).length > 0 && (
                    <Grid item xs={12}>
                      <div className="flex justify-center items-center pt-10">
                        <div className="h-[700px] w-full overflow-hidden">
                          <ShowMap
                            showSidebar={false}
                            setIsFullScreen={setIsFullScreen}
                            id={calculatorData?.clientQuery?._id}
                            portDistanceResponse={mapDistanceResponse}
                            portOperation={mapPortOperation}
                            fleetList={mapFleetList}
                          />
                        </div>
                      </div>
                    </Grid>
                  )}
              </div>
            )}
          </div>

          <CustomShowModal
            open={splitHireModal}
            handleClose={() => setSplitHireModal(false)}
            maxWidth="xs"
            title="Split Hire"
          >
            <SplitHireModal
              addNewSplitHire={addNewSplitHire}
              selectedSplitHire={selectedSplitHire}
              onChangeSplitHire={onChangeSplitHire}
            />
          </CustomShowModal>

          <CustomShowModal
            open={splitHireModalVesselOut}
            handleClose={() => setSplitHireModalVesselOut(false)}
            maxWidth="xs"
            title="Split Hire"
          >
            <SplitHireModal
              addNewSplitHire={addNewSplitHireVesselOut}
              selectedSplitHire={selectedSplitHireVesselOut?.vesselOut}
              onChangeSplitHire={onChangeSplitHireVesselOut}
            />
          </CustomShowModal>
        </div>
      </div>
    </div>
  );
}

export default VesselVesselView;
